import { getAutoCompleteSearchClient } from "dataLayer/apisWithCache/postsApis/autocomplete";
import { IAutoCompleteItems } from "models/autocomplete";
import { useRouter } from "next/router";
import { FormEvent, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import useClickOutside from "utils/misc/useClickOutsideListener";
import {
  SearchFieldParentContainer,
  SearchFieldTextContainer,
} from "./styled.components";
import { linkToFind } from "helpers/links-builders/listing";
import {
  gtmAutoCompleteCellTap,
  gtmAutoCompleteShowScreen,
 gtmOnKeywordSubmit,
  gtmSearchBtnHeader,
} from "GTMs/actions/commonActions";
import { trHelper } from "helpers/themeHelpers";
import { useGetRoutesObjects } from "contexts/RoutesObjectContext";
import { ICategoryLiteAsset } from "models/Assets/ICategoryAsset";
import { IGoToFindParams } from "models/header";
import SearchSuggestions from "../../../common/SearchSuggestions";
import { setClickStreamSearchSource } from "../../../../../../libs/clickstream/helpers/clickStreamHelpers";
import { SEARCH_SOURCE } from "utils/constants";
import {ISendLoggingEventProps, sendLoggingEvent} from "../../../../../../libs/logging/helpers/sendLoggingEvent";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3, EnumGeneratedBy, EnumLoggingScreenNames, EnumUxTypes, EnumWidgets
} from "../../../../../../libs/logging/types/loggingTypes";

interface IProps {
  placeholder: string;
  goToFind?: (newQuery: IGoToFindParams) => void;
}

const FilterSearchField = ({ placeholder, goToFind }: IProps) => {

  const router = useRouter();
  const { translations } = useTheme();
  const [suggestions, setSuggestions] = useState<IAutoCompleteItems[]>();
  const [suggestionIndex, setSuggestionIndex] = useState(-1);
  const [openMenu, setOpenMenu] = useState(false);
  const { category: categoryRouteObject } = useGetRoutesObjects();
  const [term, setTerm] = useState<string>(
    String(router?.query?.["PostSearch[term]"] || "")
  );
  const [category, setCategory] =
    useState<ICategoryLiteAsset>(categoryRouteObject);

  useClickOutside(openMenu, () => {
    setOpenMenu(false);
  });

  useEffect(() => {
    if (openMenu) {
      gtmAutoCompleteShowScreen();
    }
  }, [openMenu]);

  useEffect(() => {
    if (term !== "" && term?.length > 0 && suggestions) {
      for (let i = 0; i < suggestions.length; i++) {
        let text = suggestions[i].label;
        const n = text.toUpperCase();
        const q = term
          ?.toUpperCase()
          .replaceAll(" ", "")
          .replace(/[^\w]/gi, "");
        const x = n.indexOf(q);
        const regex = new RegExp(q);
        if (!q || x === -1) {
          // return text;
          return;
        }

        const val = text.replace(
          regex,
          '<span style="color:#1f8dd6 ' + ';">' + q + "</span>"
        );
        if (document.getElementById(`text${i}`) !== null) {
          document.getElementById(`text${i}`).innerHTML = val;
        }
      }
    }
  }, [openMenu, suggestions]);

  const checkForNumber = (val) => {
    if (!isNaN(val)) {
      const digitArr = [
        {
          label: trHelper(translations.header.searchAdsByNumberPhone, {
            __phone__: val,
          }),
          url: linkToFind({
            term: val,
            search_type: "phone",
          }),
        },
        {
          label: trHelper(translations.header.searchAdsByPostId, {
            __postId__: val,
          }),
          url: linkToFind({
            term: val,
            search_type: "id",
          }),
        },
      ];
      return digitArr;
    }
  };

  const handleFocus=()=>{
    gtmAutoCompleteCellTap()
  }

  const handleChange = async (e) => {
    const query = e.target.value;
    setTerm(query);
    if (query?.length >= 1) {
      const res = await getAutoCompleteSearchClient(null, query);
      if (res && res.length > 0) {
        setOpenMenu(true);
        setSuggestions(res);
      }
      if (res && res.length < 1) {
        const number = checkForNumber(query);
        setSuggestions(number);
        setOpenMenu(true);
      }
    } else {
      setOpenMenu(false);
    }
  };
  const sendLoggingKeywordClick =()=>{
    sendLoggingEvent({
      actionNameLvl1: EnumActionNameLevel1.SEARCH,
      actionNameLvl2: EnumActionNameLevel2.KEYWORD,
      actionNameLvl3: EnumActionNameLevel3.CLICK,
      currentWidgetName: EnumWidgets.HEADER,
      ux_type: EnumUxTypes.LIST_CELL,
      generatedBy: EnumGeneratedBy.USER,
    } as ISendLoggingEventProps);
  }
  const handleClick = (e) => {
    gtmSearchBtnHeader();
    setSuggestions([]);
    setTerm(e.label);
    sendLoggingKeywordClick()
    setOpenMenu(false);
    const route = e.url;
    window.location.href = `/${route?.replace(/^\//, "")}`;
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      if (suggestionIndex <= 0) {
        setSuggestions(undefined);
        return setSuggestionIndex(suggestions?.length);
      }
      const item = suggestions[suggestionIndex - 1].label;
      setTerm(item);
      setSuggestionIndex(suggestionIndex - 1);
    }
    // DOWN ARROW
    else if (e.keyCode === 40) {
      if (suggestionIndex >= suggestions.length - 1) {
        return setSuggestionIndex(0);
      }
      const item = suggestions[suggestionIndex + 1].label;
      setTerm(item);
      setSuggestionIndex(suggestionIndex + 1);
    }
    //ENTER
    else if (e.keyCode === 13) {
      setSuggestions(undefined);
      setTimeout(() => setOpenMenu(false), 250);
      setClickStreamSearchSource(
        !!category ? SEARCH_SOURCE.TERM_WITH_FILTERS : SEARCH_SOURCE.BY_TERM
      );
    }
  };

  // Redirect on form submit and search button
  const handleSearchRedirect = (e: FormEvent) => {
    e.preventDefault();
    gtmOnKeywordSubmit();
    sendLoggingKeywordClick();
    if (typeof suggestions != "undefined") {
      if (suggestionIndex < 0) {
        setSuggestions(undefined);
        setTimeout(() => setOpenMenu(false), 250);
        goToFind({ term, category });
      } else {
        setTerm(suggestions[suggestionIndex]?.label);
        setOpenMenu(false);
        const route = suggestions[suggestionIndex]?.full_url;
        window.location.href = `/${route?.replace(/^\//, "")}`;
        gtmSearchBtnHeader();
        setSuggestionIndex(0);
      }
    } else {
      gtmSearchBtnHeader();
      setSuggestionIndex(undefined);
      goToFind({ term: term ? term : null, category });
    }

  };

  return (
    <>
      <SearchFieldParentContainer
        onSubmit={handleSearchRedirect}
        autoComplete="off"
        className="flex-1 relative"
      >
        <SearchFieldTextContainer
          type="text"
          id="search"
          value={term}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          autoComplete="off"
          aria-label={placeholder}
          className="width-100"
        />
        {openMenu && (
          <SearchSuggestions
            suggestions={suggestions}
            currentValue={term}
            handleSearchListItem={handleClick}
            suggestionIndex={suggestionIndex}
          />
        )}
      </SearchFieldParentContainer>
      <button
        id="top_search_button"
        className="blueBtn searchBtn"
        onClick={handleSearchRedirect}
      >
        {translations.search}
      </button>
    </>
  );
};

export default FilterSearchField;
